import clsx from "clsx";

export const TableTabs = ({
  tabs,
  activeTab,
  dataTestid,
  onClick,
  className,
  classnameItem,
}: {
  tabs: string[] | { label: string; value: string; count?: number }[];
  activeTab: string;
  dataTestid?: string;
  onClick: (value: string) => void;
  className?: string;
  classnameItem?: string;
}) => (
  <div className={clsx("flex gap-x-6", className)} data-testid={dataTestid}>
    {tabs.map((tab) => {
      const label = typeof tab === "object" ? tab.label : tab;
      const value = typeof tab === "object" ? tab.value : tab;
      const count =
        typeof tab === "object"
          ? tab.count
            ? Number(tab.count)
            : 0
          : undefined;

      return (
        <button
          key={value}
          type="button"
          className={clsx(
            "flex h-10 items-center justify-center gap-x-1.5 text-200 font-bold text-black-54 md:text-300",
            value === activeTab &&
              "border-b border-b-primary-300 text-primary-300",
            classnameItem,
          )}
          onClick={() => onClick(value)}
        >
          {label}
          {!count ? null : (
            <span className="rounded-full bg-primary-100 px-1.5 py-0.5 text-90 text-white-100">
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
